export default {
  iPadLandscape: window.matchMedia('only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape)'),
  iPadPortrait: window.matchMedia('only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait)'),
  phoneLandscape: window.matchMedia('only screen and (max-device-width : 736px) and (orientation : landscape)'),
  phonePortrait: window.matchMedia('only screen and (max-device-width : 736px) and (orientation : portrait)'),
  orientation: window.matchMedia('(orientation: portrait)')
}


/** WEBPACK FOOTER **
 ** app/components/common/mediaQueries.js
 **/